import React from 'react';

function NoMatch() {
  return <div>404 No Match</div>;
}

export default NoMatch;
